import { useSite } from "./SiteContext";
import { IMAGES } from "../data/config";

// Responsive srcset for Unsplash-hosted imagery (retina + small phones).
const buildSrcSet = (src) => {
  if (!src || !src.includes("images.unsplash.com")) return undefined;
  const base = src.replace(/([?&])w=\d+/, "");
  const sep = base.includes("?") ? "&" : "?";
  return [640, 1024, 1600, 2000].map((w) => `${base}${sep}w=${w} ${w}w`).join(", ");
};

// CMS-aware image: resolves an image slot to its current media (with focal
// point), falls back to bundled defaults, and shows a tasteful DEMO badge for
// temporary photography. Accepts a raw URL too (blog posts from the CMS).
const SiteImage = ({ slot, alt = "", className = "", imgClassName = "", eager = false, badge = true, sizes }) => {
  const site = useSite();
  const slots = site?.imageSlots;
  const entry = slots ? slots[slot] : null;

  const isUrl = typeof slot === "string" && slot.startsWith("http");
  const src = entry?.url || (isUrl ? slot : IMAGES[slot]);
  const isDemo = entry ? entry.isDemo : !isUrl;
  const focal = entry?.focal || { x: 50, y: 50 };
  const resolvedAlt = alt || entry?.alt || "";

  return (
    <div className={`relative ${className}`}>
      <img
        src={src}
        srcSet={buildSrcSet(src)}
        sizes={sizes || "(max-width: 768px) 100vw, 50vw"}
        alt={resolvedAlt}
        loading={eager ? "eager" : "lazy"}
        className={imgClassName}
        style={{ objectPosition: `${focal.x}% ${focal.y}%` }}
      />
      {badge && isDemo && (
        <span
          className="absolute left-2 top-2 z-10 rounded-[2px] bg-[#171717]/85 px-1.5 py-0.5 text-[0.48rem] font-medium uppercase tracking-[0.16em] text-[#C6A46A] backdrop-blur-sm sm:left-2.5 sm:top-2.5 sm:px-2 sm:py-1 sm:text-[0.5rem]"
          data-testid={`demo-badge-${slot}`}
        >
          Demo image
        </span>
      )}
    </div>
  );
};

export default SiteImage;
